import React, { useEffect, useState } from 'react';

type ReturnType = [
  string | number,
  React.Dispatch<React.SetStateAction<string | number | null | undefined>>,
];

const useNumericInputValue = (
  valueProp: string | number | undefined | null,
): ReturnType => {
  const [localValue, setLocalValue] = useState<
    string | number | undefined | null
  >(valueProp);

  useEffect(() => {
    setLocalValue(prev => {
      if (typeof prev === 'number') {
        return valueProp;
      }

      if (Number(prev) === Number(valueProp)) {
        return prev;
      }

      return valueProp;
    });
  }, [valueProp]);

  const inputValue =
    typeof localValue === 'number' || typeof localValue === 'string'
      ? localValue
      : '';

  return [inputValue, setLocalValue];
};

export default useNumericInputValue;
